import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { api, logout } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";

let instance: AxiosInstance;
let eventInstance: AxiosInstance;
let eventInstance2: AxiosInstance;

const axiosInstance = async () => {
  instance = axios.create({
    baseURL: api + "/api/v1/division",
  });

  // Add the interceptor to the instance
  instance.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 403) {
      // logout
      logout();
    }
  });

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
};
const axiosEventInstance = async () => {
  eventInstance = axios.create({
    baseURL: api + "/event/division",
  });
  
  eventInstance2 = axios.create({
    baseURL: api + "/event/",
  });

  eventInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
  eventInstance2.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
};

axiosEventInstance();

axiosInstance();

interface ApiResponse {
  success: boolean;
  message: string;
  data?: any;
  status: number | string;
  // Add other properties as needed
}

interface CounterDraftPayload {
  tuples: { object: string };
  company_code: string;
}

// interface CreateCounterDraftPayload {
//   division_id: string;
//   counter_category: string;
//   writes: any[];
//   deletes: any[];
//   company_code: string;
// }

// interface CreateProductDraftPayload {
//   division_id: string;
//   discount_group: string;
//   writes: any[];
//   deletes: any[];
//   company_code: string;
// }

export const getAllDivisionDetails = async (): Promise<AxiosResponse> => {
  return instance.get("/details");
};

export const queryDivisionDetails = async (query: string): Promise<ApiResponse> => {
  return instance.get(query);
};

export const getModuleBasedOnDivision = async (query: string): Promise<AxiosResponse> => {
  return instance.get("/moduleDivision" + query);
};

export const getOrderAndDiscount = async (query: string): Promise<AxiosResponse> => {
  return instance.get(`/details?${query}`);
};

export const getCounterDraftHierarchyDetails = async (payload: CounterDraftPayload): Promise<AxiosResponse> => {
  return instance.post(`/counterDraft/details`, payload);
};

export const createCounterDraftHierarchy = async (payload: any): Promise<AxiosResponse> => {
  return eventInstance.post(`/counter_draft_hierarchy/add`, payload);
};
export const deleteCounterDraftHierarchy = async (payload: any): Promise<AxiosResponse> => {
  return eventInstance.delete(`/counter_draft_hierarchy/delete`, {
    data: payload,
  });
};

export const createCounterDraftHierarchyEdit = async (payload: any): Promise<AxiosResponse> => {
  return eventInstance.put(`/counter_draft_hierarchy/edit`, payload, {
    validateStatus: function (status) {
      return status < 500 && status >= 200;
    },
  });
};

export const getDiscountGroupByDivision = async (company_divisioncode: number): Promise<AxiosResponse> => {
  return instance.get("/details?discount_group=true&fields=company_divisioncode&company_divisioncode=" + company_divisioncode);
};

export const getProductDraftHierarchyDetails = async (payload: CounterDraftPayload): Promise<AxiosResponse> => {
  return instance.post(`/productDraft/details`, payload);
};

export const createProductDraftHierarchy = async (payload: any): Promise<AxiosResponse> => {
  return eventInstance2.post(`division/product_draft_hierarchy/add`, payload, {
    validateStatus: function (status) {
      return status < 500 && status >= 200;
    },
  });
};
export const deleteProductDraftHierarchy = async (payload: any): Promise<AxiosResponse> => {
  return eventInstance2.delete(`division/product_draft_hierarchy/delete`, {
    data: payload,
  });
};

export const createProductDraftHierarchyEdit = async (payload: any): Promise<AxiosResponse> => {
  return eventInstance2.put(`division/product_draft_hierarchy/edit`, payload, {
    validateStatus: function (status) {
      return status < 500 && status >= 200;
    },
  });
};

export const postAddDivision = async (payload: any) => {
  return eventInstance.post(`/add`, { data: payload, event_type: "DIVISION_ADD" });
};

export const putUpdateDivision = async (payload: any, primary_key: string) => {
  return eventInstance.put(`/edit`, { data: payload, event_type: "DIVISION_EDIT", primary_key });
};

export const checkDivisionAccess = async (divisionCode: number, companyCode: number): Promise<AxiosResponse> => {
  return instance.get(`/dgPostUsers`, {
    params: { division_code: divisionCode, company_code: companyCode },
  });
};

export const getOrderType = (division_code: number | string) => {
  return instance.get("/cndn_remarks", {
    params: { division_code },
  });
};

interface OrderDraftHierarchyPayload {
  linkType: string;
  orderType: string;
  divisionCode: string;
  companyCode: string;
  orderMode: string;
}

/**
 * Get the order draft hierarchy for a given link type, order type, division code and company code.
 * @param {OrderDraftHierarchyPayload} payload - The payload containing the parameters.
 * @returns {Promise<AxiosResponse<any>>} - The response containing the order draft hierarchy.
 */
export const getOrderDraftHierarchy = async ({
  linkType,
  orderType,
  divisionCode,
  companyCode,
  orderMode,
}: OrderDraftHierarchyPayload): Promise<AxiosResponse<any>> => {
  return instance.post("/orderDraft/details", {
    tuples: {
      object: `order-lnktype:${linkType}_${orderType}_${divisionCode}${orderMode == "manual" ? `_${orderMode}` : ""}`,
    },
    company_code: companyCode,
  });
};

export const saveOrderDraftHierarchy = async ({ payload }: { payload: any }) => {
  return eventInstance.post("/order_draft_hierarchy/add", payload);
};

export const saveOrderDraftHierarchyEdit = async ({ payload }: { payload: any }) => {
  return eventInstance.put("/order_draft_hierarchy/edit", payload, {
    validateStatus: function (status) {
      return status <= 500 && status >= 200;
    },
  });
};

export const deleteOrderDraftHierarchy = async (payload: any) => {
  return eventInstance.delete("/order_draft_hierarchy/delete", {
    data: payload,
  });
};